export const categories = [
  {
    key: "romance",
    name: "爱情片",
    genre: "爱情片",
    icon: "ri-heart-3-line",
    desc: "从心动到相守，为你们挑出最动人的爱情故事",
  },
  {
    key: "comedy",
    name: "喜剧片",
    genre: "喜剧片",
    icon: "ri-emotion-happy-line",
    desc: "一起笑出声的夜晚，比什么都治愈",
  },
  {
    key: "warm",
    name: "温情片",
    genre: "温情片",
    icon: "ri-cup-line",
    desc: "慢下来，看那些关于家、陪伴与日常的温柔",
  },
];

export const genreOptions = ["爱情片", "喜剧片", "温情片", "动画片"];

export const eraOptions = [
  { key: "nearOne", label: "近一年" },
  { key: "nearThree", label: "近三年" },
  { key: "classic", label: "经典老片" },
];

export const ratingOptions = [
  { key: "r9", label: "9.0 分以上", min: 9 },
  { key: "r8", label: "8.0 分以上", min: 8 },
  { key: "r7", label: "7.0 分以上", min: 7 },
];